import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Application, ApplicationStatus, ApplicationType } from 'app/models/application';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {
  private url = '/api/v1/applications/';

  constructor(private httpClient: HttpClient) {}

  getAll(filters: { type?: ApplicationType; status?: ApplicationStatus } = {}): Observable<Application[]> {
    const params: any = {};
    if (filters.type) params.type = filters.type;
    if (filters.status) params.status = filters.status;
    return this.httpClient.get<Application[]>(this.url, { params });
  }

  getByUser(userId: number): Observable<Application[]> {
    return this.httpClient.get<Application[]>(`${this.url}user/${userId}`);
  }

  getById(id: string): Observable<Application> {
    return this.httpClient.get<Application>(`${this.url}${id}`);
  }

  create(userId: number, applicationType: ApplicationType, formData: object): Observable<Application> {
    return this.httpClient.post<Application>(this.url, {
      user_id: userId,
      application_type: applicationType,
      form_data: formData
    });
  }

  updateForm(id: string, formData: object): Observable<{ message: string }> {
    return this.httpClient.patch<{ message: string }>(`${this.url}${id}/form`, { form_data: formData });
  }

  updateStatus(id: string, status: ApplicationStatus, userId: number): Observable<{ message: string }> {
    return this.httpClient.patch<{ message: string }>(`${this.url}${id}/status`, { status, user_id: userId });
  }

  vote(id: string, standardisation: number, engagement: number, voter: string): Observable<{ message: string }> {
    return this.httpClient.patch<{ message: string }>(`${this.url}${id}/vote`, {
      standardisation,
      engagement,
      voter
    });
  }

  getScore(applicationId: string): Observable<{score: number, nvotes: number, engVariance: number, standVariance: number}> {
    return this.httpClient.get<{score: number, nvotes: number, engVariance: number, standVariance: number}>(
      `${this.url}${applicationId}/score`
    );
  }
}
